<div fxLayout="row wrap">
  <div class="teranet-padding" fxFlex="100" fxLayout="column">
    <Teranet-PageTitle [PageTitle]="'Manage Roles'"></Teranet-PageTitle>
    <form #createform="ngForm" novalidate>
      <div class="mat-elevation-z4">
        <div fxFlex="100">
          <div fxLayout="column" fxLayoutAlign="center stretch">
            <Teranet-ClientTitle [ClientTitle]="'Lookup Role'" [IconName]="'search'"></Teranet-ClientTitle>
            <div fxLayout="row wrap" fxLayoutAlign="end">
              <div class="icon-button">
                <button mat-button (click)="add()">
                  <div class="btnicon"><fa-icon icon="plus" id="plus" class="fa-lg" matTooltipPosition="above"></fa-icon></div>
                  <div class="btntext">Add</div>
                </button>
              </div>
            </div>
            <div fxLayout.xs="column" fxLayout="row wrap">
              <div class="form-group-flex-column">
                <mat-label>Corporation</mat-label>
                <mat-form-field appearance="outline">
                  <mat-select required [(ngModel)]="clientId" (selectionChange)="onClientChange()" placeholder="--Please Select--">
                    <mat-option *ngFor="let item of clientinfos" [value]="item.id">
                      {{ item.description }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="form-group-flex-column">
                <div class="form-group-flex-column">
                  <mat-error *ngIf="message.length != 0">{{ message }}</mat-error>
                </div>
              </div>
            </div>
            <div fxLayout="row wrap" fxLayoutAlign="end">
              <button mat-raised-button class="plain-button-lg" (click)="reset()">Clear Criteria</button>
              <button mat-raised-button class="theme-button-lg" (click)="lookUp()">Lookup</button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="teranet-padding-relative" fxFlex="100">
    <ngx-spinner [fullScreen]="false"
                 type="ball-clip-rotate-multiple"
                 bdColor="rgba(51,51,51,0.8)"
                 size="medium"
                 color="#fff"></ngx-spinner>
    <Teranet-CustomizedGrid [data]="roleList"
                            [gridName]="'role-manage'"
                            [gridSettings]="gridSettings"
                            [initialGridSettings]="GridDefaultSettings()"
                            [isFinishLoading]="true"
                            [pageName]="'role-manage'"
                            (onDelete)="onDelete($event)"></Teranet-CustomizedGrid>
  </div>
</div>
